import { Selectable } from '@vestahealthcare/common/enums/Enum';
import { translate } from '@vestahealthcare/common/i18n';

export const UNASSIGNED = {
  value: 0,
  label: translate('global.unassigned'),
} as Selectable;

export type ReferralParams = {
  name?: string;
  status?: string[];
};

export type KeyGetReferralParams = keyof ReferralParams;
